const commonOcaMessage = ' Click on the link below to complete this transaction from your Online DMV Customer Portal. You will be prompted to login using your RI DMV information.';

// Maps visitTypeId -> its sub-option flow config. Add new visit types here, not in TypeSelection.vue.
export default {
  23: { // Registration
    intro: {
      title: 'Most vehicle registration transactions can be completed online.' + ' ' +
      'Please tell us what you need to do so we can guide you to the fastest option.',
    },
    options: [
      { id: 1, label: 'Register a New Vehicle', routesToSlotSelection: true },
      { id: 2, label: 'Renew an Existing Registration' },
      { id: 3, label: 'Cancel a Registration' },
      { id: 4, label: 'Get a Duplicate Registration' },
      { id: 5, label: 'Something Else', routesToSlotSelection: true },
    ],
    ocaDescriptions: {
      2: 'You do not need an appointment to renew your registration. This can be completed online in minutes.' + commonOcaMessage,
      3: 'You can cancel your registration online — no visit required.' + commonOcaMessage,
      4: 'You can request a duplicate registration online with no appointment.' + commonOcaMessage,
    },
    ocaLabels: {
      2: 'Online Registration Renewal',
      3: 'Online Cancel Registration',
      4: 'Online Duplicate Registration',
    },
    ocaLinkConfigKey: 'ONLINE_OCA_LINK', // window.config[...] key holding the URL
  },
  // future visit types add here
};
